export default __webpack_public_path__ + "static/media/figure62.88ce4222.png";